/**
 * 이용 가능한 회사 메일 도메인. 로그인은 아이디(로컬파트)만 받고 이 도메인을 붙인다.
 * 서버는 `ALLOWED_EMAIL_DOMAIN` 환경변수로 덮어쓸 수 있으나(기본값 동일),
 * 프론트 표시는 이 상수를 단일 출처로 쓴다. (CLAUDE.md 절대 규칙 5)
 */
export const EMAIL_DOMAIN = 'hecto.co.kr';
/** 아이디(로컬파트) 형식 검사. 공백·@ 불가, 1~64자. */
export function isEmailLocalPart(value) {
    return /^[a-zA-Z0-9._%+-]{1,64}$/.test(value);
}
/** 이메일 인증 코드 규칙. 프론트 입력 필드도 이 값을 쓴다. */
export const AUTH_CODE = {
    /** 자리수(숫자만) */
    length: 6,
    /** 토큰 하나당 허용 오입력 횟수. 초과하면 그 코드는 즉시 폐기된다. */
    maxAttempts: 5,
};
/** 입력값에서 숫자만 남긴다(공백·하이픈 붙여넣기 허용). */
export function normalizeAuthCode(raw) {
    return raw.replace(/\D/g, '').slice(0, AUTH_CODE.length);
}
export function isAuthCodeShaped(value) {
    return new RegExp(`^\\d{${AUTH_CODE.length}}$`).test(value);
}
//# sourceMappingURL=auth.js.map